export default "__VITE_ASSET__1ccd4c96__"